module.exports = __webpack_public_path__ + "img/connector-types.67b8f579.webp";